import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { forcarRecarga } from "@/components/app/staleChunkRecovery";

/**
 * Última linha de defesa: se algo estourar na raiz do app, o usuário vê um
 * botão em vez de uma tela branca. Erro de chunk velho já recarrega sozinho
 * (ver staleChunkRecovery) — isso aqui cobre o resto.
 */
export const AppCrashFallback = ({ error }: { error?: Error }) => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
    <h1 className="text-xl font-semibold">Não foi possível carregar a página</h1>
    <p className="max-w-md text-sm text-muted-foreground">
      Recarregue a página para continuar.
    </p>
    <Button type="button" onClick={forcarRecarga} className="gap-2">
      <RefreshCw className="h-4 w-4" />
      Recarregar
    </Button>
    {import.meta.env.DEV && error && (
      <pre className="max-w-full overflow-auto text-left text-xs text-destructive">
        {error.message}
      </pre>
    )}
  </div>
);
